import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, lambda_type, unit_type, string_type, int32_type, record_type, array_type, class_type, option_type, bool_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { DocTreeAssign_$reflection, DocTreeAssign, DocumentCategory, DocumentCategory_$reflection, Machine_$reflection, Document$_$reflection } from "../Shared/ApiDataTypes.js";
import { Tree_filterLeafs, Tree_filter, Tree_map, Tree_append, Tree$2, Tree_appendCata, Tree_fold, Tree_cata, Tree$2_$reflection } from "../Shared/Tree.js";
import { bind, value as value_30, unwrap, some, defaultArg, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { find, choose, map as map_1, singleton, append, contains as contains_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { int32ToString, equals, createObj, uncurry2, structuralHash } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Button, TableCell, TextField, Skeleton, MenuItem } from "@mui/material";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_2, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { isNullOrWhiteSpace, join, printf, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { strIContains, Documents_DocumentSource, Documents_DocumentSource__get_Id, tryStr } from "../Shared/Shared.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { wrapTooltip } from "../ViewHelpers.js";
import CloudUpload from "@mui/icons-material/CloudUpload";
import PanTool from "@mui/icons-material/PanTool";
import Sync from "@mui/icons-material/Sync";
import { parseDateIso, sortFn } from "../Utils.js";
import { toDateStr } from "../Locale.js";
import Edit from "@mui/icons-material/Edit";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export class TreeState extends Record {
    constructor(IsOpen, HideForm, UploadForm, DeleteForm, DragHovering) {
        super();
        this.IsOpen = IsOpen;
        this.HideForm = HideForm;
        this.UploadForm = UploadForm;
        this.DeleteForm = DeleteForm;
        this.DragHovering = DragHovering;
    }
}

export function TreeState_$reflection() {
    return record_type("DocumentHelpers.TreeState", [], TreeState, () => [["IsOpen", bool_type], ["HideForm", option_type(Document$_$reflection())], ["UploadForm", option_type(array_type(class_type("Browser.Types.File")))], ["DeleteForm", option_type(Document$_$reflection())], ["DragHovering", bool_type]]);
}

export class SortInfo extends Record {
    constructor(Id, Key, Asc) {
        super();
        this.Id = (Id | 0);
        this.Key = Key;
        this.Asc = Asc;
    }
}

export function SortInfo_$reflection() {
    return record_type("DocumentHelpers.SortInfo", [], SortInfo, () => [["Id", int32_type], ["Key", string_type], ["Asc", bool_type]]);
}

export function SortInfo_ToString_7D8512D8(info, lang) {
    if (lang.tag === 1) {
        const matchValue_3 = info.Key;
        const matchValue_4 = info.Asc;
        switch (matchValue_3) {
            case "Date":
                if (matchValue_4) {
                    return "Date newest";
                }
                else {
                    return "Dato olders";
                }
            case "Title":
                if (matchValue_4) {
                    return "Name alphabetical";
                }
                else {
                    return "Name reversed";
                }
            default:
                throw new Error("Unsupported sort info");
        }
    }
    else {
        const matchValue = info.Key;
        const matchValue_1 = info.Asc;
        switch (matchValue) {
            case "Date":
                if (matchValue_1) {
                    return "Dato eldste";
                }
                else {
                    return "Dato nyeste";
                }
            case "Title":
                if (matchValue_1) {
                    return "Navn alfabetisk";
                }
                else {
                    return "Navn reversert";
                }
            default:
                throw new Error("Unsupported sort info");
        }
    }
}

export class DocumentFilter extends Record {
    constructor(Sort, SearchTerm, HideNonSynced, ShowDeleted) {
        super();
        this.Sort = Sort;
        this.SearchTerm = SearchTerm;
        this.HideNonSynced = HideNonSynced;
        this.ShowDeleted = ShowDeleted;
    }
}

export function DocumentFilter_$reflection() {
    return record_type("DocumentHelpers.DocumentFilter", [], DocumentFilter, () => [["Sort", SortInfo_$reflection()], ["SearchTerm", string_type], ["HideNonSynced", bool_type], ["ShowDeleted", bool_type]]);
}

export function DocumentFilter_get_empty() {
    return new DocumentFilter(new SortInfo(1, "", true), "", false, false);
}

export class DragTarget extends Record {
    constructor(Document$, FromTopLevel) {
        super();
        this.Document = Document$;
        this.FromTopLevel = FromTopLevel;
    }
}

export function DragTarget_$reflection() {
    return record_type("DocumentHelpers.DragTarget", [], DragTarget, () => [["Document", Document$_$reflection()], ["FromTopLevel", bool_type]]);
}

export class DocumentDragForm extends Record {
    constructor(DragTarget, OnMoved) {
        super();
        this.DragTarget = DragTarget;
        this.OnMoved = OnMoved;
    }
}

export function DocumentDragForm_$reflection() {
    return record_type("DocumentHelpers.DocumentDragForm", [], DocumentDragForm, () => [["DragTarget", DragTarget_$reflection()], ["OnMoved", lambda_type(unit_type, unit_type)]]);
}

export class MachineCategory extends Record {
    constructor(Machine, Trees) {
        super();
        this.Machine = Machine;
        this.Trees = Trees;
    }
}

export function MachineCategory_$reflection() {
    return record_type("DocumentHelpers.MachineCategory", [], MachineCategory, () => [["Machine", Machine_$reflection()], ["Trees", array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection()))]]);
}

export const globalDocumentSortKeys = [new SortInfo(0, "Date", true), new SortInfo(1, "Date", false), new SortInfo(2, "Title", true), new SortInfo(3, "Title", false)];

export function emptyCategory(versionOpt, parentOpt) {
    return new DocumentCategory(-1, map((parent) => parent.Id, parentOpt), versionOpt, undefined, true, defaultArg(map((parent_1) => parent_1.PtgOnly, parentOpt), false), true, false, "", "", "", "", []);
}

/**
 * Tests whether there exists any documents in a given tree's children
 */
export function treeHasDocuments(children) {
    return children.some((tree) => Tree_cata((_arg) => true, (_arg_1, children_1) => contains_1(true, children_1, {
        Equals: (x, y) => (x === y),
        GetHashCode: structuralHash,
    }), tree));
}

export function collectCategories(lang, categories) {
    return Tree_fold((acc, _arg) => acc, (acc_1, category) => append(acc_1, singleton(MuiHelpers_createElement(MenuItem, [["key", category.Id], ["value", category.Id], ["children", (lang.tag === 0) ? category.NameNO : category.NameEN]]))), [], categories);
}

export function addDocument(categoryId, document$, tree) {
    return Tree_appendCata((node) => (node.Id === categoryId), [new Tree$2(0, [document$])], tree);
}

export function addDocuments(categoryId, documents, tree) {
    return Tree_append((node) => (node.Id === categoryId), map_1((Item) => (new Tree$2(0, [Item])), documents), tree);
}

export function updateCategory(updated, tree) {
    return Tree_map((x) => x, (existing) => {
        if (existing.Id === updated.Id) {
            return updated;
        }
        else {
            return existing;
        }
    }, tree);
}

export function updateDocument(updated, tree) {
    return Tree_map((document$) => {
        if (document$.Guid === updated.Guid) {
            return updated;
        }
        else {
            return document$;
        }
    }, (x) => x, tree);
}

export function removeNode(toRemove, tree) {
    return Tree_filter((doc) => {
        if (toRemove.tag === 0) {
            return doc.Guid !== toRemove.fields[0].Guid;
        }
        else {
            return true;
        }
    }, (node) => {
        if (toRemove.tag === 1) {
            return node.Id === toRemove.fields[0].Id;
        }
        else {
            return true;
        }
    }, tree);
}

export function removeCategory(categoryId, tree) {
    return Tree_filter((_arg) => true, (node) => (node.Id !== categoryId), tree);
}

export function removeDocument(documentId, tree) {
    return Tree_filterLeafs((doc) => (doc.Guid !== documentId), (_arg) => true, tree);
}

export function moveDocHere(docForm, treeId, machineId, callback) {
    let properties_2;
    let pr_1;
    const item = new DocTreeAssign(machineId, treeId, docForm.DragTarget.Document.Guid, undefined);
    const data = some(Auto_generateBoxedEncoder_437914C6(DocTreeAssign_$reflection(), undefined, undefined, undefined)(item));
    const decoder = Auto_generateBoxedDecoder_Z6670B51(DocTreeAssign_$reflection(), undefined, undefined);
    const data_1 = data;
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/machine-document-tree/assign", properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocTreeAssign_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_1.then((res) => {
        callback(res);
    });
}

export function deleteSubEntry(entryToDelete, entries) {
    return choose((tree) => removeNode(entryToDelete, tree), entries);
}

/**
 * Reads a documents contents and returns its size as a formatted string like: 105.65MB or 1.25GB
 */
export function formatDocumentSize(bytes) {
    const kb = bytes / 1000;
    if (kb <= 1) {
        return toText(printf("%iB"))(bytes);
    }
    else {
        const mb = kb / 1000;
        if (mb <= 1) {
            return toText(printf("%0.2fkB"))(kb);
        }
        else {
            const gb = mb / 1000;
            if (gb <= 1) {
                return toText(printf("%0.2fMB"))(mb);
            }
            else {
                return toText(printf("%0.2fGB"))(gb);
            }
        }
    }
}

export function getDocumentUploader(uploader) {
    if (uploader == null) {
        return "Systemet";
    }
    else {
        const uploader_1 = value_30(uploader);
        return defaultArg(bind((firstName) => map((lastName) => toText(printf("%s %s"))(firstName)(lastName), tryStr(uploader_1.LastName)), tryStr(uploader_1.FirstName)), uploader_1.Email);
    }
}

export function docLoadingIndicator() {
    return MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
        width: 100 + "%",
        height: 20,
    }]]);
}

export function docsLoadingIndicators() {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 3 + "px ",
    }], (elems = [docLoadingIndicator(), docLoadingIndicator(), docLoadingIndicator()], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function sortSelect(lang, locale, onUpdate, current) {
    let elems;
    return MuiHelpers_createElement(TextField, [["id", "document-sort-select"], ["label", locale.t("Document.SortBy")], ["select", true], ["size", "small"], ["sx", {
        flexBasis: 220 + "px",
    }], ["value", current.Id], ["onChange", (ev) => {
        const id = ev.target.value | 0;
        onUpdate(find((key_7) => (key_7.Id === id), globalDocumentSortKeys));
    }], (elems = [MuiHelpers_createElement(MenuItem, [["value", -1], ["children", createElement("em", {
        children: ["N/A"],
    })]]), map_1((s) => MuiHelpers_createElement(MenuItem, [["children", SortInfo_ToString_7D8512D8(s, lang)], ["value", s.Id]]), globalDocumentSortKeys)], ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

export function filterHeaderBar(children) {
    return createElement("div", {
        className: join(" ", ["large-max-width"]),
        style: {
            display: "flex",
            alignItems: "center",
            paddingTop: 5 + "px",
            width: 100 + "%",
            gap: 20 + "px",
            flexWrap: "wrap",
        },
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export function filenameCell(href, document$, children) {
    let elements, elems_1;
    return MuiHelpers_createElement(TableCell, [["title", document$.Title], ["style", {
        fontSize: 0.8 + "rem",
        minWidth: 10 + "ch",
        maxWidth: 0,
        width: 65 + "%",
        whiteSpace: "nowrap",
        overflowX: "hidden",
        textOverflow: "ellipsis",
    }], ["variant", "body"], (elements = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => append_1((document$.ContentId != null) ? singleton_1(createElement("a", {
        href: href,
        target: "_blank",
        children: reactApi.Children.toArray([document$.Title]),
    })) : singleton_1(createElement("span", {
        children: document$.Title,
    })), delay(() => singleton_1(children))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

export function syncColumn(locale, document$) {
    let elements;
    return MuiHelpers_createElement(TableCell, [["style", {
        fontSize: 0.75 + "rem",
    }], ["variant", "body"], ["padding", "checkbox"], (elements = toList(delay(() => {
        let props_1, props_3, props_7, props_5;
        return (document$.SourceId === Documents_DocumentSource__get_Id(new Documents_DocumentSource(2, []))) ? singleton_1(wrapTooltip(locale.t("Document.UploadedFromKundeWeb"), (props_1 = {
            style: {
                fontSize: 22 + "px",
                marginLeft: 5,
                color: "#87CEFA",
            },
        }, react.createElement(CloudUpload, props_1)))) : (document$.ManuallyMoved ? singleton_1(wrapTooltip(locale.t("Document.ManuallyMoved"), (props_3 = {
            style: {
                fontSize: 22 + "px",
                marginLeft: 5,
                color: "#FF4500",
            },
        }, react.createElement(PanTool, props_3)))) : ((document$.ContentId != null) ? singleton_1(wrapTooltip(locale.t("Document.Synchronized"), (props_7 = {
            style: {
                fontSize: 22 + "px",
                marginLeft: 5,
                color: "#87CEFA",
            },
        }, react.createElement(Sync, props_7)))) : singleton_1(wrapTooltip(locale.t("Document.AwaitingSync"), (props_5 = {
            style: {
                fontSize: 22 + "px",
                marginLeft: 5,
                color: "#FFA500",
            },
        }, react.createElement(Sync, props_5))))));
    })), ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

export function hiddenColumn(children) {
    return MuiHelpers_createElement(TableCell, [["style", {
        fontSize: 0.75 + "rem",
    }], ["variant", "body"], ["padding", "checkbox"], ["align", "center"], ["children", reactApi.Children.toArray(Array.from(children))]]);
}

export function sourceColumn(x) {
    return MuiHelpers_createElement(TableCell, [["style", {
        maxWidth: 10 + "%",
        fontSize: 0.75 + "rem",
        textAlign: "left",
    }], ["variant", "body"], ["children", reactApi.Children.toArray(Array.from(x))]]);
}

export function dateColumn(x) {
    return MuiHelpers_createElement(TableCell, [["style", {
        fontSize: 0.75 + "rem",
    }], ["variant", "body"], ["children", reactApi.Children.toArray(Array.from(x))]]);
}

export function actionColumn(x) {
    return MuiHelpers_createElement(TableCell, [["variant", "body"], ["padding", "checkbox"], ["style", {
        fontSize: 0.75 + "rem",
        textAlign: "center",
    }], ["children", reactApi.Children.toArray(Array.from(x))]]);
}

/**
 * First filter docs by name if any search filter set then sort by date/name
 */
export function filterDocs(lang, catOpt, docFilter, documents) {
    let documents_1, contains;
    const searchTerm = docFilter.SearchTerm;
    return sortFn(docFilter.Sort.Asc, docFilter.Sort.Key)((documents_1 = documents, (isNullOrWhiteSpace(searchTerm) && (catOpt == null)) ? documents_1 : ((contains = ((str_1) => strIContains(searchTerm, str_1)), documents_1.filter((document$) => {
        if (docFilter.ShowDeleted ? true : !document$.IsDeleted) {
            if ((isNullOrWhiteSpace(searchTerm) ? true : contains(document$.Title)) ? true : defaultArg(map((arg_2) => contains(toDateStr(lang, parseDateIso(arg_2))), document$.Date), false)) {
                return true;
            }
            else {
                return equals(document$.CategoryTreeId, catOpt);
            }
        }
        else {
            return false;
        }
    })))));
}

export function categoryButton(isAdmin, categoryStr, onClick) {
    let elems;
    return createElement("div", createObj(singleton_2((elems = [MuiHelpers_createElement(Button, toList(delay(() => append_1(singleton_1(["style", createObj(toList(delay(() => append_1(singleton_1(["fontSize", 0.66 + "rem"]), delay(() => (!isAdmin ? singleton_1(["cursor", "default"]) : empty_1()))))))]), delay(() => append_1(singleton_1(["onClick", (ev) => {
        if (isAdmin) {
            onClick(ev);
        }
    }]), delay(() => append_1(singleton_1(["size", "small"]), delay(() => append_1(singleton_1(["disableRipple", !isAdmin]), delay(() => append_1(singleton_1(["fullWidth", false]), delay(() => append_1(singleton_1(["children", categoryStr]), delay(() => {
        let props_1;
        return isAdmin ? singleton_1(["endIcon", (props_1 = {
            style: {
                fontSize: 0.8 + "rem",
                cursor: "pointer",
                marginLeft: 5,
            },
        }, react.createElement(Edit, props_1))]) : empty_1();
    })))))))))))))))], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function docTableTextHeader(text) {
    return MuiHelpers_createElement(TableCell, [["style", {
        fontSize: 0.8 + "rem",
    }], ["variant", "head"], ["align", "left"], ["children", text]]);
}

export function docTableIconHeader(child) {
    return MuiHelpers_createElement(TableCell, [["style", {
        fontSize: 0.8 + "rem",
    }], ["variant", "head"], ["padding", "checkbox"], ["align", "center"], ["children", child]]);
}

export function docTableButtonHeader() {
    return MuiHelpers_createElement(TableCell, [["variant", "head"], ["padding", "checkbox"]]);
}

export class Table {
    constructor() {
    }
}

export function Table_$reflection() {
    return class_type("DocumentHelpers.Table", undefined, Table);
}

export function Table_FilenameCell_Z6EA07FE8(table_FilenameCell_Z6EA07FE8InputProps) {
    let elements, elems_1;
    const startAdornments = table_FilenameCell_Z6EA07FE8InputProps.startAdornments;
    const children = table_FilenameCell_Z6EA07FE8InputProps.children;
    const machineId = table_FilenameCell_Z6EA07FE8InputProps.machineId;
    const document$ = table_FilenameCell_Z6EA07FE8InputProps.document;
    const customerId = table_FilenameCell_Z6EA07FE8InputProps.customerId;
    const groupId = table_FilenameCell_Z6EA07FE8InputProps.groupId;
    const children_1 = defaultArg(children, []);
    const startAdornments_1 = defaultArg(startAdornments, []);
    return MuiHelpers_createElement(TableCell, [["title", document$.Title], ["style", {
        fontSize: 0.8 + "rem",
        maxWidth: 60 + "ch",
    }], ["variant", "body"], (elements = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => append_1(singleton_1(startAdornments_1), delay(() => append_1((document$.ContentId != null) ? singleton_1(createElement("a", {
        className: join(" ", ["text-overflow"]),
        href: RouterModule_encodeParts(ofArray(append(["group", int32ToString(groupId), "customer", int32ToString(customerId)], (machineId != null) ? ["machine", int32ToString(value_30(machineId)), "documents", document$.Guid] : ["documents", document$.Guid])), 1),
        children: reactApi.Children.toArray([document$.Title]),
    })) : singleton_1(createElement("span", {
        className: join(" ", ["text-overflow"]),
        children: document$.Title,
    })), delay(() => singleton_1(children_1))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

